import {  TiposDeDados } from "@/core/config/PerfisConfig";

class Nota {  
    public static campos = () => {
        return [  
            // {
            //     nome: "disciplina",
            //     type: "text",
            //     label: "Disciplina",
            //     sm: 12,
            //     lg: 6, 
            //     disabled: true
            // },  
            // {
            //     nome: "turma",
            //     type: "text",
            //     label: "Turma",
            //     sm: 12,
            //     lg: 6, 
            //     disabled: true
            // },  
            // {
            //     nome: "forma",
            //     type: "text",
            //     label: "Forma de Avaliação",
            //     sm: 12,
            //     lg: 6, 
            //     disabled: true
            // },  
            // {
            //     nome: "tipo",
            //     type: "text",
            //     label: "Prova",
            //     sm: 12,
            //     lg: 6, 
            //     disabled: true
            // },  
            {
                nome: "notaValor",
                type: "number",
                label: "Nota",
                sm: 12,
                lg: 6, 
                disabled: false
            },  
        ];
    }   
}
  
export   {   Nota };
